export enum GridCellKind
{
    Timestamp = 'Timestamp',

    FrameColumnHeader = 'FrameColumnHeader',
    FrameRowHeader = 'FrameRowHeader',
    FrameCell = 'FrameCell',

    TextHeader = 'TextHeader',
    Text = 'Text',

    Icon = 'Icon',
    Letter = 'Letter'
}
